import { ApplicationRootState } from 'store/types';

const selectBackOfficeEnterprise = (state: ApplicationRootState) =>
  state.backOfficeEnterprise;

export default selectBackOfficeEnterprise;
